// Componente de presentación de un paso del onboarding
import type { OnboardingStepData } from './onboardingSteps';

interface OnboardingStepProps {
  step: OnboardingStepData;
}

export function OnboardingStep({ step }: OnboardingStepProps) {
  const Icon = step.icon;

  return (
    <div className="flex flex-col items-center text-center px-4">
      <div className="rounded-full bg-emerald-100 dark:bg-emerald-900/30 p-4 mb-4">
        <Icon className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
        {step.title}
      </h3>
      <p className="text-gray-600 dark:text-gray-400 mb-4 max-w-md">
        {step.description}
      </p>
      <ul className="text-left space-y-2 w-full max-w-md">
        {step.items.map((item) => (
          <li
            key={item}
            className="flex items-start gap-2 text-sm text-gray-700 dark:text-gray-300"
          >
            <span className="text-emerald-500 mt-0.5 flex-shrink-0">•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
